/** Minimal Web Audio helpers: play note sequences for Melodías. */

const NOTE_FREQ = {
  C4: 261.63, 'C#4': 277.18, D4: 293.66, 'D#4': 311.13, E4: 329.63,
  F4: 349.23, 'F#4': 369.99, G4: 392.0, 'G#4': 415.3, A4: 440.0,
  'A#4': 466.16, B4: 493.88, C5: 523.25, D5: 587.33, E5: 659.25,
  G5: 783.99, A5: 880.0,
}

let ctx = null
function getCtx() {
  if (typeof window === 'undefined') return null
  const AC = window.AudioContext || window.webkitAudioContext
  if (!AC) return null
  if (!ctx) ctx = new AC()
  if (ctx.state === 'suspended') ctx.resume()
  return ctx
}

export function noteToFreq(note) {
  return NOTE_FREQ[note] || 440
}

function tone(ctx, freq, start, dur, type = 'triangle', peak = 0.22) {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()
  osc.type = type
  osc.frequency.value = freq
  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur)
  osc.connect(gain).connect(ctx.destination)
  osc.start(start)
  osc.stop(start + dur + 0.02)
}

/** Play an array of note strings (or freqs). Returns total ms. */
export function playNotes(notes, { noteDur = 0.34, gap = 0.06, onStep } = {}) {
  const c = getCtx()
  if (!c) return 0
  const t0 = c.currentTime + 0.05
  notes.forEach((n, i) => {
    const freq = typeof n === 'number' ? n : noteToFreq(n)
    const start = t0 + i * (noteDur + gap)
    tone(c, freq, start, noteDur)
    if (onStep) setTimeout(() => onStep(i), i * (noteDur + gap) * 1000)
  })
  return notes.length * (noteDur + gap) * 1000 + 120
}

export function playTone(freq, dur = 0.3) {
  const c = getCtx()
  if (!c) return
  tone(c, freq, c.currentTime + 0.02, dur)
}
